<s1-input-select [control]="control" [itemsList]="fasce" [label]="label" [readonly]="readonly"></s1-input-select>